import React, { createContext, useState, useContext, useEffect } from 'react';
import Anthropic from '@anthropic-ai/sdk';

// Create a Context
const ClientContext = createContext();

// Create a Provider Component
export const ClientProvider = ({ children }) => {

   const [apiKey, setApiKey] = useState(() => {
     return sessionStorage.getItem('anthropicApiKey') // Retrieve stored API key
   });
  const [client, setClient] = useState(null);

  // Initialize or update the client when the apiKey changes
  useEffect(() => {
    if (!apiKey) {
        setClient(null);
        return;
    }
    
    try {
        const newClient = new Anthropic({
        apiKey: apiKey,
        dangerouslyAllowBrowser: true,
        });
        setClient(newClient);
        sessionStorage.setItem('anthropicApiKey', apiKey);
    } catch (error) {
        console.error('Failed to initialize Anthropic client:', error);
        setClient(null); // Ensure client isn't set in case of failure
    }
  }, [apiKey]);

  return (
    <ClientContext.Provider value={{ client, apiKey, setApiKey }}>
      {children}
    </ClientContext.Provider>
  );
};

// Custom hook for accessing the Client Context
export const useClient = () => useContext(ClientContext);
